import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '../lib/featureFlags/FeatureFlagProvider';

type FeatureFlagRouteProps = {
    flag: string;
    redirectTo: string;
    children: React.ReactNode;
};

export const FeatureFlagRoute: React.FC<FeatureFlagRouteProps> = ({ flag, redirectTo, children }) => {
    const isEnabled = useFeatureFlag(flag);

    if (!isEnabled) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
};
